import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Menu } from 'primereact/menu';
import { confirmDialog } from 'primereact/confirmdialog';
import { Chip } from 'primereact/chip';

import fetchApi from '../lib/fetchApi.js';
import pkg from '../../package.json';

const SidebarContainer = ({ currentPageAlias }) => {
  const navigate = useNavigate();
  const [me, setMe] = useState(null);
  const [menuItems, setMenuItems] = useState([]);

  const ALL_ITEMS = [
    { label: '儀表板',     icon: 'pi pi-home',        alias: 'dashboard',  url: '/dashboard' },
    { label: '報價記錄',   icon: 'pi pi-folder',      alias: 'quotation',  url: '/quotation', permission: 'quotation' },
    { label: '新增報價',   icon: 'pi pi-file-plus',   alias: 'orderform',  url: '/orderform', permission: 'orderform' },
    { label: '用戶管理',   icon: 'pi pi-users',       alias: 'user',       url: '/user',      permission: 'user' },
    { separator: true },
    { label: <>登出 <span className="text-xs">(v{pkg.version})</span></>, icon: 'pi pi-sign-out',    command: () => askLogout() },
  ];

  useEffect(() => {
    (async () => {
      const response = await fetchApi('/api/v1/user/getMe');
      if (response?.state === 1 && response.data?.user) {
        setMe(response.data.user);
      } else {
        navigate('/');
      }
    })();
  }, []);

  useEffect(() => {
    if (!me) return;
    const permIds = (me.permissions || []).map((p) => (typeof p === 'string' ? p : p.id));
    const items = ALL_ITEMS
      .filter((it) => !it.permission || permIds.includes(it.permission))
      .map((it) => ({ ...it, className: currentPageAlias === it.alias ? 'p-focus' : '' }));
    setMenuItems(items);
  }, [me, currentPageAlias]);

  const logout = async () => {
    await fetchApi('/api/v1/user/logout');
    navigate('/');
  };

  const askLogout = () => {
    confirmDialog({
      message: '你確定要登出系統嗎？',
      header: '確定登出',
      icon: 'pi pi-info-circle',
      defaultFocus: 'reject',
      acceptClassName: 'p-button-info',
      accept: () => logout(),
    });
  };

  if (!me) return null;

  return (
    <div className="flex flex-column h-full justify-content-between">
      <Menu model={menuItems} className="w-full border-none" />
      <div className="p-3">
        <Chip label={me.nickname || me.fullname || me.username} icon="pi pi-user" className="w-full border-round-sm" />
      </div>
    </div>
  );
};

export default SidebarContainer;
